export interface AdvisorSupportEmail {
  id: string;
  from: string;
  fromEmail: string;
  to: string;
  subject: string;
  date: string;
  body: string;
  accountNumber: string;
  clientName: string;
  currentRegistration: string;
  proposedRegistration: string;
  instructionType: 'overwrite' | 'replace';
  priority: 'urgent' | 'high' | 'normal';
  sla: string;
}

export const ADVISOR_SUPPORT_EMAILS: AdvisorSupportEmail[] = [
  {
    id: 'adv-001',
    from: 'Michael Torres',
    fromEmail: 'm.torres@northpoint.com',
    to: 'ops@northpoint.com',
    subject: '1234-5657 [SMITH JANE C]',
    date: 'Today, 9:14 AM',
    body: "Update registration to 'Vanguard 40/60'. Thank you.",
    accountNumber: '1234-5657',
    clientName: 'SMITH JANE C',
    currentRegistration: 'SMITH JANE C',
    proposedRegistration: 'SMITH JANE C Vanguard 40/60',
    instructionType: 'overwrite',
    priority: 'high',
    sla: '6h left',
  },
  {
    id: 'adv-002',
    from: 'Rachel Kim',
    fromEmail: 'r.kim@harbormgmt.com',
    to: 'ops@northpoint.com',
    subject: 'Update Registration',
    date: 'Today, 8:52 AM',
    body: '9876-5432 [SMITH JANE K] remove "Jane Smith Sm Cap" and replace with "GAMMA SP500"',
    accountNumber: '9876-5432',
    clientName: 'SMITH JANE K',
    currentRegistration: 'SMITH JANE K Jane Smith Sm Cap',
    proposedRegistration: 'SMITH JANE K GAMMA SP500',
    instructionType: 'replace',
    priority: 'urgent',
    sla: '2h left',
  },
  {
    id: 'adv-003',
    from: 'David Park',
    fromEmail: 'd.park@northpoint.com',
    to: 'ops@northpoint.com',
    subject: '3344-1122 [JONES ROBERT M] - strategy update',
    date: 'Today, 8:31 AM',
    body: "Please change the registration to 'BlackRock 60/40 Conservative'. Client confirmed at yesterday's review meeting.",
    accountNumber: '3344-1122',
    clientName: 'JONES ROBERT M',
    currentRegistration: 'JONES ROBERT M',
    proposedRegistration: 'JONES ROBERT M BlackRock 60/40 Conservative',
    instructionType: 'overwrite',
    priority: 'normal',
    sla: '1d left',
  },
  {
    id: 'adv-004',
    from: 'Lisa Nguyen',
    fromEmail: 'l.nguyen@coastalwm.com',
    to: 'ops@northpoint.com',
    subject: 'Registration Name Update',
    date: 'Today, 7:48 AM',
    body: "Hi — can you update account 5566-7788 [CHEN PATRICIA L]? Remove 'PIMCO Income' and add 'PIMCO Total Return'. Client switched strategies last week.",
    accountNumber: '5566-7788',
    clientName: 'CHEN PATRICIA L',
    currentRegistration: 'CHEN PATRICIA L PIMCO Income',
    proposedRegistration: 'CHEN PATRICIA L PIMCO Total Return',
    instructionType: 'replace',
    priority: 'high',
    sla: '4h left',
  },
  {
    id: 'adv-005',
    from: 'Michael Torres',
    fromEmail: 'm.torres@northpoint.com',
    to: 'ops@northpoint.com',
    subject: '2211-8844 [WILLIAMS DAVID T]',
    date: 'Today, 7:22 AM',
    body: 'Please update to Fidelity Growth Strategy. Client requested this change at his quarterly review yesterday.',
    accountNumber: '2211-8844',
    clientName: 'WILLIAMS DAVID T',
    currentRegistration: 'WILLIAMS DAVID T',
    proposedRegistration: 'WILLIAMS DAVID T Fidelity Growth Strategy',
    instructionType: 'overwrite',
    priority: 'normal',
    sla: '1d left',
  },
  {
    id: 'adv-006',
    from: 'James Chen',
    fromEmail: 'j.chen@harbormgmt.com',
    to: 'ops@northpoint.com',
    subject: 'Quick reg change',
    date: 'Yesterday, 4:55 PM',
    body: "Team — for account 7799-3366 [BROWN SARAH K], please update the registration to 'iShares Core S&P 500 Index'. She's moving from active to passive.",
    accountNumber: '7799-3366',
    clientName: 'BROWN SARAH K',
    currentRegistration: 'BROWN SARAH K',
    proposedRegistration: 'BROWN SARAH K iShares Core S&P 500 Index',
    instructionType: 'overwrite',
    priority: 'normal',
    sla: '1d left',
  },
  {
    id: 'adv-007',
    from: 'Rachel Kim',
    fromEmail: 'r.kim@harbormgmt.com',
    to: 'ops@northpoint.com',
    subject: '8833-4411 [ANDERSON JAMES R] reg update',
    date: 'Yesterday, 3:12 PM',
    body: "Remove 'JP Morgan Balanced' and replace with 'T. Rowe Price 70/30'. Client approved at meeting last week.",
    accountNumber: '8833-4411',
    clientName: 'ANDERSON JAMES R',
    currentRegistration: 'ANDERSON JAMES R JP Morgan Balanced',
    proposedRegistration: 'ANDERSON JAMES R T. Rowe Price 70/30',
    instructionType: 'replace',
    priority: 'normal',
    sla: 'Done',
  },
  {
    id: 'adv-008',
    from: 'Lisa Nguyen',
    fromEmail: 'l.nguyen@coastalwm.com',
    to: 'ops@northpoint.com',
    subject: 'Strategy Name Swap',
    date: 'Yesterday, 2:30 PM',
    body: "1122-5566 [TAYLOR LINDA P] — please remove 'Vanguard Growth' and replace with 'Vanguard Value Index'. She switched from growth to value last quarter.",
    accountNumber: '1122-5566',
    clientName: 'TAYLOR LINDA P',
    currentRegistration: 'TAYLOR LINDA P Vanguard Growth',
    proposedRegistration: 'TAYLOR LINDA P Vanguard Value Index',
    instructionType: 'replace',
    priority: 'normal',
    sla: 'Done',
  },
  {
    id: 'adv-009',
    from: 'David Park',
    fromEmail: 'd.park@northpoint.com',
    to: 'ops@northpoint.com',
    subject: '4455-9900 [MILLER THOMAS J]',
    date: 'Yesterday, 11:05 AM',
    body: "Hi, can you set the registration to 'Schwab US Equity ETF Portfolio' for this account? Tom mentioned it at our last call.",
    accountNumber: '4455-9900',
    clientName: 'MILLER THOMAS J',
    currentRegistration: 'MILLER THOMAS J',
    proposedRegistration: 'MILLER THOMAS J Schwab US Equity ETF Portfolio',
    instructionType: 'overwrite',
    priority: 'normal',
    sla: 'Done',
  },
  {
    id: 'adv-010',
    from: 'Michael Torres',
    fromEmail: 'm.torres@northpoint.com',
    to: 'ops@northpoint.com',
    subject: 'Registration update request',
    date: 'Yesterday, 9:40 AM',
    body: "For 6677-2233 [DAVIS KAREN M], please update to 'Dimensional US Core Equity'. Karen signed the IPS amendment last week.",
    accountNumber: '6677-2233',
    clientName: 'DAVIS KAREN M',
    currentRegistration: 'DAVIS KAREN M',
    proposedRegistration: 'DAVIS KAREN M Dimensional US Core Equity',
    instructionType: 'overwrite',
    priority: 'normal',
    sla: 'Done',
  },
];
